import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import { Global } from './../globals';
import { AlertService } from './alert.service';
import { Router } from '@angular/router';
import { BookingRequest } from './../_models/booking/booking-request.model';
import { ItemRequest } from '../_models/item/item-request.model';
import { CustomerRequest } from '../_models/customer/customer-request.model';
import { AppConfig } from './../app.config';


import utils from './../utils';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root' 
})
export class SignalRService {
    private hubConnection: HubConnection;
    private hubUrl: string;
    messages: string[] = [];
    response: any;
    private registeredEvents: { [eventName: string]: any; } = {};
    private awaitResponseEvents: { [eventName: string]: any; } = {};
    hubConfig: any;
    constructor(private globals: Global, private alertService: AlertService, private router: Router, private config: AppConfig, private blockUI: LoadingService) {
        //this.startConnection();
    }

    public startConnection(): void {

        // this.hubUrl = "http://culturasignalrgateway.azurewebsites.net/Gateway";//this.config.getConfig('hubUrl');
        this.hubUrl = this.config.hubUrl;
        this.hubConnection = new HubConnectionBuilder().withUrl(this.addQueryString(this.hubUrl)).build();

        this.hubStart(10);
        this.On('NotAuthenticated', () => {
            if (utils.isAuthenticated()) {
                this.router.navigate(['/login']);
                this.blockUI.stop();
                this.alertService.error("Session timeout");
            }
        });
        this.On('AgentDoNotExist', () => {
            this.router.navigate(['/login']);
            this.blockUI.stop();
            this.alertService.error("Agent down, Please contact administrator.");
        });
        this.On('Error', (exception) => {
            this.blockUI.stop();
            this.alertService.error(exception.Message + " Please contact administrator.");
            console.log(exception);
            setTimeout(() => { this.alertService.clear(); }, 5000);
        });
    }
    private addQueryString(Url: string): string {
        // var gatewayKey: string = "203f5af5-d94f-42db-9280-729cde26ac02";
        var gatewayKey: string = this.config.gatewayKey;
        return Url + '?sessionToken=' + (sessionStorage.getItem('sessionToken') || '') + '&GatewayKey=' + gatewayKey;
    }
    private hubStart(retry: number) {
        this.alertService.clear();
        this.alertService.error("Connecting to server", false, false, true);
        this.hubConnection
            .start()
            .then(() => {
                console.log('Connection started!');
                this.globals.signalRHub = this.hubConnection;
                this.alertService.clear();
                this.blockUI.stop();
                //If registered event exist on previous hubconnection re-register them to new hubconnection
                for (let event in this.registeredEvents) {
                    let callback = this.registeredEvents[event];
                    this.On(event, callback);
                }
            })
            .catch(err => {
                console.log('Error while establishing connection :(', err);
                if (retry) {
                    this.hubConnection = new HubConnectionBuilder().withUrl(this.addQueryString(this.hubUrl)).build();
                    setTimeout(() => this.hubStart(retry), retry * 1000);
                }
            });

        this.hubConnection.onclose(() => {
            console.log('connection closed');
            this.hubStart(5);
        });
    }
    public On(eventName: string, callbackFunction: any) {
        if (this.registeredEvents[eventName]) {
            this.hubConnection.off(eventName, this.registeredEvents[eventName]);
            this.registeredEvents[eventName] = null;
        }
        if (this.awaitResponseEvents[eventName]) {
            clearTimeout(this.awaitResponseEvents[eventName]);
            this.awaitResponseEvents[eventName] = null;
        }
        this.hubConnection.on(eventName, callbackFunction);
        this.registeredEvents[eventName] = callbackFunction;
    }
    public OnResponse(eventName: string, callbackFunction: any) {
        var _callbackFunction: any = function (eventName: string, callbackFunction: any, response: any) {
            clearTimeout(this.awaitResponseEvents[eventName]);
            this.awaitResponseEvents[eventName] = null;
            callbackFunction(response);
        }.bind(this, eventName, callbackFunction)
        this.On(eventName, _callbackFunction);
        this.awaitResponseEvents[eventName] = setTimeout(this.ResponseLost.bind(this, eventName, _callbackFunction), parseInt(this.config.timeoutInSeconds) * 1000);
    }
    private ResponseLost(eventName: string) {
        this.hubConnection.off(eventName, this.registeredEvents[eventName]);
        this.registeredEvents[eventName] = null;
        this.blockUI.stop();
        this.alertService.error("Could not recieve result. Please contact administrator.", false, true);
        this.awaitResponseEvents[eventName] = null;
    }

    public SearchCustomers(cutomerRequest: CustomerRequest): void {
        this.hubConnection
            .invoke('FetchCustomerList', sessionStorage.getItem('sessionToken'), cutomerRequest)
            .catch(this.errorResponse);
    }
    public FetchCustomerCreditDetails(nameId: string): void {
        this.hubConnection
            .invoke('FetchCustomerCreditDetail', sessionStorage.getItem('sessionToken'), nameId)
            .catch(this.errorResponse);
    }
    public SearchItems(itemRequest: ItemRequest): void {
        this.hubConnection
            .invoke('SearchItems', sessionStorage.getItem('sessionToken'), itemRequest)
            .catch(this.errorResponse);
    }
    public PostBooking(bookingRequest: BookingRequest): void {

        this.hubConnection
            .invoke('BookItems', sessionStorage.getItem('sessionToken'), bookingRequest)
            .catch(this.errorResponse);
    }
    public FetchBookings(status: string): void {
        this.hubConnection
            .invoke('FetchBookingsList', sessionStorage.getItem('sessionToken'), status)
            .catch(this.errorResponse);
    }
    public AuthenticateUser(username: string, password: string): void {
        this.hubConnection
            .invoke('login', username, password)
    }
    public location(): void {
        this.hubConnection
            .invoke('FetchLocationsList', sessionStorage.getItem('sessionToken'))
            .catch(this.errorResponse);
    }


    public logOut(): void {
        this.hubConnection
            .invoke('LogOut', sessionStorage.getItem('sessionToken'))
            .catch(this.errorResponse);
    }


    errorResponse = (error) => {
        this.blockUI.stop();
        this.alertService.error(error);
    };
}